import React, { useContext } from 'react';

import Translations from '../helpers/translation';

let t = new Translations();
t.init('en_US');

export const TranslationContext = React.createContext(t);

export const useTranslation = () => useContext(TranslationContext);

// JS port of \Phrase::slug()
// e.g. "How are you?! Today!" -> "how_are_you_today"
export const slugifyPhrase = (phrase) => {
    return phrase
        .trim()
        .replace(/[^a-zA-Z0-9_ ]+/g, '')
        .replace(/\s+/g, '_')
        .toLowerCase();
};

export const withTranslation = (WrappedComponent) => {
    return (props) => {
        const { t } = useContext(TranslationContext);
        return <WrappedComponent {...props} t={t} />
    }
}
